import { getElement } from '../Utility/Dom'

class PublisherNoteModal {
  private readonly cancelButton: HTMLElement | null
  private readonly closeButton: HTMLElement | null
  private readonly confirmLink: HTMLAnchorElement | null
  private readonly dialog: HTMLDialogElement | null
  private publisherUrl: null | URL = null

  constructor() {
    this.cancelButton = getElement('publisher-note-cancel')
    this.closeButton = getElement('publisher-note-close')
    this.confirmLink = getElement('publisher-note-confirm') as HTMLAnchorElement | null
    this.dialog = getElement('publisher-note-modal') as HTMLDialogElement | null
  }

  public init(): void {
    if (this.dialog === null || this.confirmLink === null) return

    this.publisherUrl = this.resolveUrl(this.dialog.dataset.publisherUrl)
    if (this.publisherUrl === null) return

    this.addEvents()
  }

  private addEvents(): void {
    document.addEventListener('click', (event: MouseEvent): void => this.handleDocumentClick(event))

    this.cancelButton?.addEventListener('click', (): void => this.dialog?.close())

    this.closeButton?.addEventListener('click', (): void => this.dialog?.close())

    this.dialog?.addEventListener('click', (event: MouseEvent): void => {
      if (event.target === this.dialog) this.dialog.close()
    })

    this.confirmLink?.addEventListener('click', (): void => this.dialog?.close())
  }

  private handleDocumentClick(event: MouseEvent): void {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

    const target = event.target as HTMLElement | null
    const link = target?.closest('a[href]') as HTMLAnchorElement | null
    if (link === null || this.confirmLink === null || link === this.confirmLink) return

    const url = this.resolveUrl(link.href)
    if (url === null || !this.pointsToPublisher(url)) return

    event.preventDefault()

    this.confirmLink.href = link.href
    this.confirmLink.target = '_blank'
    this.confirmLink.rel = link.rel

    this.dialog?.showModal()
  }

  private pointsToPublisher(url: URL): boolean {
    if (this.publisherUrl === null || url.origin !== this.publisherUrl.origin) return false

    const base = this.publisherUrl.pathname.replace(/\/$/, '')
    if (base === '') return true

    return url.pathname === base || url.pathname.startsWith(`${base}/`)
  }

  private resolveUrl(value: string | undefined): null | URL {
    if (value === undefined || value === '') return null

    try {
      return new URL(value, window.location.href)
    } catch {
      return null
    }
  }
}

const publisherNoteModal = new PublisherNoteModal()
publisherNoteModal.init()
